<!--
 * @Author: Victor victorqwer1234567890@gmail.com
 * @Date: 2023-12-27 18:27:55
 * @LastEditors: Merlin
 * @LastEditTime: 2025-06-23 15:27:27
 * @FilePath: /gamefi/components/Modal/index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
    <Teleport to="body">
        <div
            v-if="modelValue"
            v-bind="$attrs"
            @click.self="() => onBackdrop()"
            class="inset-0 overflow-y-auto z-[1111] bg-[#030b15d9] justify-center overflow-x-hidden fixed flex items-center w-full md:inset-0 max-h-full"
            :class="wrapClassName"
            :style="style"
            :scopeid="scopeid"
        >
            <!-- ↑ 遮罩层 -->
            <!-- ↓ 弹出的窗口 -->
            <Transition name="scales" appear>
                <div
                    class="dialog bg-[#111923] m-2 relative rounded-2xl"
                    :class="[defaultModalSize, containerClass]"
                >
                    <slot class="relative"></slot>
                </div>
            </Transition>
        </div>
    </Teleport>
</template>

<script lang="ts">
export default defineComponent({ name: 'Modal' });
</script>

<script lang="ts" setup>
const props = defineProps({
    modelValue: {
        type: Boolean,
        required: true,
    },
    backdrop: {
        type: Boolean,
        default: true,
    },
    title: {
        type: String,
        default: '',
    },
    containerClass: {
        type: String,
        default: '',
    },
    drawer: { // 抽屉模式，向上弹出，用于小屏幕 
        type: Boolean,
        default: true, // 尝试默认启用 
    },
    class: [Object, String], // 声明出来，否则控制台打印 warn 信息 
    style: [Object, String], // 声明出来，否则控制台打印 warn 信息 
    scopeid: String, // 声明出来，否则控制台打印 warn 信息（意为 scope id, 但属性名全小写）
});

const wrapClassName = computed(() => {
    let sResult = props.class || '';
    if (props.drawer === true){
        sResult += ' drawer';
    };
    return sResult;
});



const defaultModalSize = 'w-[530px] ';
const emit = defineEmits(['update:modelValue', 'click']); // 声明 click 事件，否则控制台打印 warn 信息 
const close = () => {
    emit('update:modelValue', false);
};
const onBackdrop = () => {
    if (props.backdrop) {
        close();
    }
};

// ↓ 窗口开关之后要修改滚动条规则
watch(
    () => props.modelValue,
    (value) => {
        if (import.meta.server) return; 
        const sValue = value ? 'hidden' : 'auto';
        if (value){
            document.body.style.overflow = sValue;
        }      
    },
    {
        immediate: true
    }
);


</script>

<style scoped lang="scss">
// ↓ 抽屉模式在【小屏幕】时才启动，
@media screen and (max-width: 915px){
    .drawer .dialog{
        margin: 0;
        max-width: 100vw;
        min-height: 100px; // 若无危害就保留 
        max-height: 90vh;
        align-self: flex-end; // 沉底
    }
    .drawer .dialog,
    .drawer .dialog > :deep(*){
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 0;
    }
    // ↓ 覆盖默认动画效果 
    .drawer{
        .scales-enter-from,
        .scales-leave-to {
            transform: translateY(70%); // 暴露 30%，然后向上升起 
        }
        .scales-enter-active,
        .scales-leave-active {
            transition: transform 0.2s ease-out;
        }
        .scales-enter-to,
        .scales-leave-from {
            transform: translateY(0);
        }
    }
}

@media screen and (max-width: 450px){
    .drawer .dialog{
        width: 100%;
        max-width: 100%; 
    }
}


.scales-enter-from,
.scales-leave-to {
    transform: scale(0.65);
}
.scales-enter-active,
.scales-leave-active {
    transition: transform 80ms ease-in-out;
}
.scales-enter-to,
.scales-leave-from {
    transform: scale(1);
}

</style>

